<template>
<div class="task-overview-component">
    <!--                TODO: NEEDS TO HAVE THE ProductCategory Type to get all productCategories by Type -->
    <div class="flex-col gap-y-sm">
      <div class="flex-row justify-content-between align-items-center">
        <div class="flex-row gap-sm align-items-center">
          <template v-if="selected.length">
            <dd-button v-if="displayActiveTasks" @click="completeSelected" type="success" :small="true"  >
              <template #icon>
                <CheckIcon></CheckIcon>
              </template>
              {{ selected.length }} Afronden
            </dd-button>
            <dd-button v-else @click="restoreSelected" type="success" :small="true" >
              <template #icon>
                <RestoreIcon></RestoreIcon>
              </template>
              {{ selected.length }} Activeren
            </dd-button>
          </template>
          <div class="flex-row my-auto gap-sm">
            <dd-filter-pill v-if="labelIds.length" @click="setLabelIds([])">Op label</dd-filter-pill>
            <dd-filter-pill v-if="displayActiveTasks">Alleen actieve</dd-filter-pill>
            <dd-filter-pill v-else>Alleen afgeronde</dd-filter-pill>
          </div>
        </div>

        <a-dropdown :trigger="['click']">
          <div class="flex-row">
            <dd-filter-button @click="openFilterDropdown"></dd-filter-button>
          </div>

          <template #overlay>
            <dd-header-card header="Filters">
              <div class="flex-col gap-sm">
                <label-filter :productCategory="ProductCategoryEnum.TASK"></label-filter>
                <dd-radio-group @input="loadTasksPage" v-model="interval" title="Type taak">
                  <dd-radio :value="365">
                    Actieve
                  </dd-radio>
                  <dd-radio :value="-365">
                    Afgeronde
                  </dd-radio>
                </dd-radio-group>
              </div>
            </dd-header-card>
          </template>
        </a-dropdown>
      </div>

      <dd-main-table
          v-if="hasTasks"
          @load-page="(value) => loadPageObject = value"
          @update-selected="(value) => (selected = value)"
          :rounded="true"
          :headers="tableHeaders"
          :rows="tasks"
          actionWidth="146px"
          :pagination="pagination"
      >
        <template v-slot:actions="{ row }">
          <div class="flex-row gap-sm">
<!-- TODO implement           -->
<!--            <dd-button-->
<!--                :href="route('vue.task.show', { task: row.id, customer: customerId })"-->
<!--                type="primary"-->
<!--                :outline="true"-->
<!--                :small="true"-->
<!--                class="square-button flex-row"-->
<!--                title="Bekijken"-->
<!--            >-->
<!--              <template #icon>-->
<!--                <EyeIcon></EyeIcon>-->
<!--              </template>-->
<!--            </dd-button>-->
            <dd-button
                :href="route('vue.task.edit', { task: row.id, customer: customerId })"
                type="primary"
                :outline="true"
                :small="true"
                class="square-button flex-row"
                title="Bewerken"
            >
              <template #icon>
                <PencilIcon class="icon-size-md m-auto"></PencilIcon>
              </template>
            </dd-button>
            <dd-button
                v-if="displayActiveTasks"
                type="secondary"
                @click="onCheckClick(row)"
                :small="true"
                class="square-button flex-row"
                title="Afronden"
            >
              <template #icon>
                <CheckIcon class="icon-size-md m-auto"></CheckIcon>
              </template>
            </dd-button>
            <dd-button
                v-else
                type="secondary"
                @click="onRestoreTask(row)"
                :small="true"
                class="square-button flex-row"
                title="Her-activeren"
            >
              <template #icon>
                <RestoreIcon class="icon-size-md m-auto"></RestoreIcon>
              </template>
            </dd-button>
          </div>
        </template>
      </dd-main-table>
    </div>


    <div v-if="hasTasks === false" class="widget-body" style="margin: 1.5rem;">
      <p>Er zijn geen {{ displayActiveTasks ? 'onafgehandelde' : 'afgeronde' }} taken.</p>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex'
import {ProductCategoryEnum} from '~/enums'
import taskApi from '~/api/task'
import store from '~/store';
import TaskPriority from './cell_types/TaskPriority.vue';
import taskModule from './store'
import MultipleAvatarsCell from "../../../new_design_components/tables/cell_types/MultipleAvatarsCell.vue";
import CustomerAvatarCell from '../../../new_design_components/tables/cell_types/CustomerAvatarCell.vue';
import LabelFilter from './components/LabelFilter.vue';
import TaskDescriptionCell from "./cell_types/TaskDescriptionCell.vue";

export default {
  name: 'PaginatedTasksComponent',
  components: {
    LabelFilter
  },
  props: {
    departmentId: {
      type: Number,
      default: null
    },
    userId: {
      type: Number,
      required: true
    },
    page: {
      type: Number,
      default: 1
    },
  },
  data () {
    return {
      interval: 365,
      includes: [
          'users.avatar',
      ],
      loadPageObject: {
        page: 1,
        perPage: 15,
      },
      tasks: [],
      currentRequestData: {},
      selected: [],
      loading: true,
      initialized: false,
      showFilterDropdown: false,
      ProductCategoryEnum: ProductCategoryEnum,
      tableHeaders: [
        {
          "title": "Omschrijving",
          typeComponent: TaskDescriptionCell,
        },
        {
          "title": "Klant",
          key: (row) => {
            if ('customer' in row) return row.customer.data;
                return undefined;
          },
          typeComponent: CustomerAvatarCell,
          width: '150px',
        },
        {
          "title": "Toegewezen aan",
          typeComponent: MultipleAvatarsCell,
          key: (row) => {
            let avatars = row.users.data.map((user) => ({
              name: user.fullname,
              src:  `/user/${user.id}/avatar`,
            }))
            avatars = [
                ...avatars,
                ...row.departments.data.map((department) => ({
                  name: department.name,
                  src: ``,
                }))
            ];
            return avatars;
          },
          width: '250px',
        },
        {
          "title": "Datum",
          key: (row) => row.formatted_date,
          width: '150px',
        },
      ],
    }
  },
  beforeCreate() {
    if (!store.hasModule('task')) {
      store.registerModule('task', taskModule);
    }
  },
  created() {
    this.loadTasksPage(this.loadPageObject.page, true);
  },
  computed: {
    ...mapState({
      instance: 'instance',
      category_id: 'category_id',
      familyLoaded: 'familyLoaded',
    }),
    ...mapState(`$_customer_page`, {
      customerId: 'customerId',
    }),
    ...mapGetters(`$_customer_page`, {
      familyArray: 'familyArray',
    }),
    ...mapGetters([
      'forceIntersect'
    ]),
    ...mapGetters('task', [
      'name',
      'selectedTasks',
      'perPage',
      'labelIds'
    ]),
    indeterminate () {
      return this.allSelected === false
          && this.currentSelectionDiff !== this.tasks.length
          && this.currentSelectionDiff > 0
    },
    currentSelectionDiff () {
      return this.tasks.filter(i => this.selectedTasks.findIndex(x => x.id === i.id) < 0).length
    },
    hasSelection () {
      return this.selectedTasks.length > 0
    },
    selectedUnlinkableTasks () {
      return this.selectedTasks.filter(task => typeof task.customer !== 'undefined' && task.customer !== null)
    },
    hasUnlinkableSelection () {
      return this.selectedUnlinkableTasks.length > 0
    },
    displayActiveTasks () {
      return this.interval >= 0
    },
    hasTasks () {
      return (this.initialized && this.tasks.length > 0) || !this.initialized
    },
    pagination() {
      return this.currentRequestData?.meta?.pagination;
    }
  },
  methods: {
    ...mapMutations(`task`, {
      setLabelIds: 'SET_LABEL_IDS',
    }),
    ...mapActions('task', [
      'setPerPage',
    ]),
    ...mapActions(`$_customer_page`, {
      getAttachablesCount: 'getAttachablesCount',
    }),
    onCheckClick(task) {
      taskApi.completeTask(task.id, this.userId, this.interval).then((res) => {
        this.loadTasksPage(this.loadPageObject.page, true);
        this.getAttachablesCount();
      });
    },
    onRestoreTask(task) {
      taskApi.activateTask(task.id, this.userId, this.interval).then((res) => {
        this.loadTasksPage(this.loadPageObject.page, true);
        this.getAttachablesCount();
      });
    },
    restoreSelected() {
      taskApi.activateTasks(this.selected, this.userId, this.interval).then((res) => {
        this.loadTasksPage(this.loadPageObject.page, true);
        this.getAttachablesCount();
      });
    },
    completeSelected() {
      taskApi.completeTasks(this.selected, this.userId, this.interval).then((res) => {
        this.loadTasksPage(this.loadPageObject.page, true);
        this.getAttachablesCount();
      });
    },

    openFilterDropdown() {
      this.showFilterDropdown = true;
    },
    loadTasksPage (page = 1, forceReload = false) {
      if (!this.familyArray) return;
      if (page === this.loadPageObject.page && forceReload !== true) {
        return
      }
      this.loading = true

      if (this.instance && Object.keys(this.instance).length) {
        this.getTasksForInstance();
      }
      else if (this.category_id) {
        this.getTasksForCategory();
      }
    },
    getTasksForInstance() {
      if (this.displayActiveTasks) {
        taskApi.getActiveByInstance(this.instance, this.interval, this.loadPageObject.page, this.loadPageObject.perPage, this.includes)
            .then((response) => this.handleResponse(response))
            .catch(() => this.throwError());
      }
      else {
        taskApi.getCompletedByInstance(this.instance, this.interval, this.loadPageObject.page, this.loadPageObject.perPage, this.includes)
            .then((response) => this.handleResponse(response))
            .catch(() => this.throwError());
      }
    },
    getTasksForCategory() {
      if (this.displayActiveTasks) {
        taskApi.getActiveByCustomerIdsAndCategory(
[...this.familyArray.map((customer) => customer.id)],
            this.category_id,
            this.interval,
            this.loadPageObject.page,
            this.loadPageObject.perPage,
            this.includes)
            .then((response) => this.handleResponse(response))
            .catch((e) => {
            }
            );
      }
      else {
        taskApi.getCompletedByCustomerIdsAndCategory(
            [...this.familyArray.map((customer) => customer.id)],
            this.category_id,
            this.interval,
            this.loadPageObject.page,
            this.loadPageObject.perPage,
            this.includes)
            .then((response) => this.handleResponse(response))
            .catch(() => this.throwError());
      }
    },
    handleResponse(response) {
      this.allSelected = false
      this.tasks = response.data
      this.currentRequestData = response
      this.loading = false
      this.initialized = true
      this.loadPageObject = { ...this.loadPageObject, page: this.pagination?.current_page, perPage: this.pagination?.per_page };
    },
    throwError() {
      this.$notification['error']({
        message: 'Er ging iets mis',
        description: 'Het is niet gelukt om taken te laden',
      })
    },
    onUnmatchAllClick () {
      this.loading = true

      taskApi.unmatchTasks(this._.map(this.selectedTasks, 'id')).then(() => {
        this.loading = false
        // trigger reload
        for (let i in this.selectedTasks) {
          this.selectedTasks[i].customer = null
        }
      }).catch(() => {
        this.$notification['error']({
          message: 'Er ging iets mis',
          description: 'Kon de geselecteerde taken niet ontkoppelen',
        })
      })
    },
    onCompleteAllClick () {
      this.loading = true
      taskApi.completeTasks(this._.map(this.selectedTasks, 'id'), this.userId, this.interval).then(response => {
        // trigger reload
        this.loadTasksPage(this.loadPageObject.page, true)
        this.deselectAllTasks()

        // TODO remove when push notifications are set up for this count
        response.meta.departmentTasksCounts.forEach((departmentTasksCount) => {
          this.processBadges(
              '.badge.department-task-count[data-id="' + departmentTasksCount.department_hashid + '"]',
              this.displayActiveTasks ? departmentTasksCount.activeCount : departmentTasksCount.completedCount,
          )
        })
        response.meta.userTasksCounts.forEach((userTasksCounts) => {
          this.processBadges(
              '.badge.user-task-count[data-id="' + userTasksCounts.user_hashid + '"]',
              this.displayActiveTasks ? userTasksCounts.activeCount : userTasksCounts.completedCount,
          )
        })

        // Total
        // this.processBadges('.tasks-panel-count', response.meta.count);
        // this.processBadges('.total-campaigns-count', response.meta.count);
      }).catch(error => {
        console.error(error)
        this.$notification['error']({
          message: 'Er ging iets mis',
          description: 'Kon de geselecteerde taken niet verwerken',
        })
      })
    },
    onActivateAllClick () {
      this.loading = true
      taskApi.activateTasks(this._.map(this.selectedTasks, 'id'), this.userId, this.interval).then(response => {
        // trigger reload
        this.loadTasksPage(this.loadPageObject.page, true)
        this.deselectAllTasks()

        // TODO remove when push notifications are set up for this count
        response.meta.departmentTasksCounts.forEach((departmentTasksCount) => {
          this.processBadges(
              '.badge.department-task-count[data-id="' + departmentTasksCount.department_hashid + '"]',
              this.displayActiveTasks ? departmentTasksCount.activeCount : departmentTasksCount.completedCount,
          )
        })
        response.meta.userTasksCounts.forEach((userTasksCounts) => {
          this.processBadges(
              '.badge.user-task-count[data-id="' + userTasksCounts.user_hashid + '"]',
              this.displayActiveTasks ? userTasksCounts.activeCount : userTasksCounts.completedCount,
          )
        })

        // Total
        // this.processBadges('.tasks-panel-count', response.meta.count);
        // this.processBadges('.total-campaigns-count', response.meta.count);
      }).catch(error => {
        this.$notification['error']({
          message: 'Er ging iets mis',
          description: 'Kon de geselecteerde taken niet activeren',
        })
      })
    },
    processBadges (badge, count) {
      let $badge = $(badge)
      if (count === 0) {
        $badge.addClass('hidden')
      } else {
        $badge.removeClass('hidden').text(count)
      }
    },
    onCompleted () {
      this.loadTasksPage(this.loadPageObject.page, true)
    },
    onUnmatched () {
      // this.loadTasksPage(this.loadPageObject.page);
    },
    onDateChanged () {
      this.loadTasksPage(this.loadPageObject.page, true)
    },
    handlePerPageChange (perPage) {
      this.setPerPage(perPage)
      this.loadTasksPage(this.loadPageObject.page, true)
    },
    intersected () {
      if (!this.initialized) {
        this.loadTasksPage(this.loadPageObject.page)
      }
    },
    onFilterSelect() {
      if (this.initialized) {
      if (this.labelIds.length > 0) {
        this.getByLabelIds(this.labelIds)
      } else {
        this.loadTasksPage(1, true)
      }
    }},
  },
  watch: {
    interval() {
     this.onFilterSelect();
    },
    labelIds () {
      this.onFilterSelect();
    },
  },
}
</script>

<style scoped>
tr th.half-padding {
  padding: 4px;
}

tbody.loading {
  opacity: .5;
}

table th.compact, table td.compact {
  white-space: nowrap;
  width: 1px !important;
}
</style>
